(function () {
    "use strict";

    angular.module('app').factory('organisationService', OrganisationService);

    OrganisationService.$inject = [];
    function OrganisationService() {
        return { currentTab: '', };
    }
})();
